var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","stroke":"currentColor","strokeWidth":"2"},React.createElement("path",{"d":"M4 4h16M4 12h16M4 20h16"})));
}

HamburgerInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
